document.addEventListener('DOMContentLoaded', () => {
  const PUBLIC_TOKEN = '2a1feb6370795a3e9650560d236dfbd6';
  const API_VERSION = '2026-07';

  let requestNumber = 0;
  let debounceTimer = null;

  const DEFAULT_PROVINCE_CODES = {
    IT: 'RM',
    IE: 'D',
    PT: '11',
    RO: 'B',
    ES: 'M',
    US: 'NY'
  };

  const mutation = `
    mutation ShippingRate($input: CartInput!) {
      cartCreate(input: $input) {
        cart {
          deliveryGroups(first: 10) {
            nodes {
              deliveryOptions {
                title
                estimatedCost {
                  amount
                  currencyCode
                }
              }
            }
          }
        }
        userErrors {
          field
          message
        }
      }
    }
  `;

  function getShippingBlock() {
    return document.getElementById(
      'NeedCartShippingRate'
    );
  }

  async function getCurrentCart() {
    const root =
      window.Shopify?.routes?.root || '/';

    const response = await fetch(
      `${root}cart.js`,
      {
        method: 'GET',
        headers: {
          Accept: 'application/json'
        }
      }
    );

    if (!response.ok) {
      throw new Error(
        `Cart request failed: ${response.status}`
      );
    }

    return response.json();
  }

  function buildStorefrontLines(cart) {
    return cart.items
      .filter(item => {
        return (
          item.variant_id &&
          Number(item.quantity) > 0
        );
      })
      .map(item => ({
        merchandiseId:
          `gid://shopify/ProductVariant/${item.variant_id}`,
        quantity: Number(item.quantity)
      }));
  }

  function escapeHtml(value) {
    const element =
      document.createElement('div');

    element.textContent = String(value);

    return element.innerHTML;
  }

  function formatMoney(
    amount,
    currencyCode
  ) {
    return new Intl.NumberFormat(
      document.documentElement.lang || 'en',
      {
        style: 'currency',
        currency: currencyCode,
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
      }
    ).format(amount);
  }

  async function calculateCartShipping() {
    const shippingBlock =
      getShippingBlock();

    if (!shippingBlock) {
      return;
    }

    const countryCode =
      shippingBlock.dataset.countryCode;

    const countryName =
      shippingBlock.dataset.countryName;

    if (!countryCode) {
      shippingBlock.hidden = true;
      return;
    }

    const currentRequest =
      ++requestNumber;

    shippingBlock.classList.add(
      'is-loading'
    );

    try {
      const cart =
        await getCurrentCart();

      if (currentRequest !== requestNumber) {
        return;
      }

      const lines =
        buildStorefrontLines(cart);

      if (!lines.length) {
        shippingBlock.hidden = true;
        return;
      }

      const provinceCode =
        DEFAULT_PROVINCE_CODES[countryCode] ||
        null;

      const deliveryAddress = {
        countryCode
      };

      if (provinceCode) {
        deliveryAddress.provinceCode =
          provinceCode;
      }

      const variables = {
        input: {
          lines,
          buyerIdentity: {
            countryCode
          },
          delivery: {
            addresses: [
              {
                address: {
                  deliveryAddress
                },
                selected: true,
                oneTimeUse: true,
                validationStrategy:
                  'COUNTRY_CODE_ONLY'
              }
            ]
          }
        }
      };

      const response = await fetch(
        `/api/${API_VERSION}/graphql.json`,
        {
          method: 'POST',
          headers: {
            'Content-Type':
              'application/json',
            'X-Shopify-Storefront-Access-Token':
              PUBLIC_TOKEN
          },
          body: JSON.stringify({
            query: mutation,
            variables
          })
        }
      );

      const result =
        await response.json();

      if (currentRequest !== requestNumber) {
        return;
      }

      if (!response.ok) {
        console.error(
          'Shipping API HTTP error:',
          response.status,
          result
        );

        shippingBlock.hidden = true;
        return;
      }

      if (result.errors?.length) {
        console.error(
          'Shipping API GraphQL errors:',
          result.errors
        );

        shippingBlock.hidden = true;
        return;
      }

      const userErrors =
        result?.data?.cartCreate
          ?.userErrors || [];

      if (userErrors.length) {
        console.error(
          'Shipping API user errors:',
          userErrors
        );

        shippingBlock.hidden = true;
        return;
      }

      const groups =
        result?.data?.cartCreate?.cart
          ?.deliveryGroups?.nodes || [];

      if (!groups.length) {
        shippingBlock.hidden = true;
        return;
      }

      /*
       * Находим самый дешёвый способ доставки
       * отдельно в каждой delivery group.
       */
      const cheapestByGroup =
        groups.map(group => {
          const options =
            group.deliveryOptions || [];

          if (!options.length) {
            return null;
          }

          return options.reduce(
            (lowest, current) => {
              const currentPrice =
                Number(
                  current.estimatedCost.amount
                );

              const lowestPrice =
                Number(
                  lowest.estimatedCost.amount
                );

              return currentPrice <
                lowestPrice
                ? current
                : lowest;
            }
          );
        });

      if (
        cheapestByGroup.some(
          option => !option
        )
      ) {
        shippingBlock.hidden = true;
        return;
      }

      const currencyCode =
        cheapestByGroup[0]
          .estimatedCost.currencyCode;

      /*
       * Складываем минимальную стоимость
       * всех delivery groups.
       */
      const totalShipping =
        cheapestByGroup.reduce(
          (total, option) => {
            return total + Number(
              option.estimatedCost.amount
            );
          },
          0
        );

      /*
       * cart.total_price приходит в центах.
       * Например 82400 = €824.00.
       */
      const subtotal =
        Number(cart.total_price) / 100;

      const estimatedTotal =
        subtotal + totalShipping;

      const formattedSubtotal =
        formatMoney(
          subtotal,
          currencyCode
        );

      const formattedShipping =
        formatMoney(
          totalShipping,
          currencyCode
        );

      const formattedTotal =
        formatMoney(
          estimatedTotal,
          currencyCode
        );

      shippingBlock.innerHTML = `
        <div class="need-cart-summary">
          <div class="need-cart-summary__row">
            <span class="need-cart-summary__label">
              Subtotal
            </span>

            <strong class="need-cart-summary__value">
              ${escapeHtml(formattedSubtotal)}
            </strong>
          </div>

          <div class="need-cart-summary__row">
            <span class="need-cart-summary__label">
              Shipping to
              ${escapeHtml(countryName)}
            </span>

            <strong class="need-cart-summary__value">
              ${escapeHtml(formattedShipping)}
            </strong>
          </div>

          <div class="need-cart-summary__divider"></div>

          <div class="need-cart-summary__row need-cart-summary__total">
            <span class="need-cart-summary__label">
              Estimated total
            </span>

            <strong class="need-cart-summary__value">
              ${escapeHtml(formattedTotal)}
            </strong>
          </div>
        </div>
      `;

      shippingBlock.hidden = false;
    } catch (error) {
      if (currentRequest !== requestNumber) {
        return;
      }

      console.error(
        'Cart shipping rate failed:',
        error
      );

      shippingBlock.hidden = true;
    } finally {
      shippingBlock.classList.remove(
        'is-loading'
      );
    }
  }

  function scheduleCalculation(
    delay = 400
  ) {
    window.clearTimeout(
      debounceTimer
    );

    debounceTimer =
      window.setTimeout(
        calculateCartShipping,
        delay
      );
  }

  document.addEventListener(
    'change',
    event => {
      if (
        event.target.matches(
          'input[name="updates[]"], input.quantity__input'
        )
      ) {
        scheduleCalculation(700);
      }
    }
  );

  document.addEventListener(
    'input',
    event => {
      if (
        event.target.matches(
          'input[name="updates[]"], input.quantity__input'
        )
      ) {
        scheduleCalculation(700);
      }
    }
  );

  document.addEventListener(
    'click',
    event => {
      if (
        event.target.closest(
          'quantity-input .quantity__button'
        ) ||
        event.target.closest(
          'cart-remove-button'
        )
      ) {
        scheduleCalculation(900);
      }
    }
  );

  const originalFetch =
    window.fetch;

  window.fetch = async (...args) => {
    const response =
      await originalFetch(...args);

    const requestUrl =
      typeof args[0] === 'string'
        ? args[0]
        : args[0]?.url || '';

    if (
      requestUrl.includes(
        '/cart/change'
      ) ||
      requestUrl.includes(
        '/cart/update'
      ) ||
      requestUrl.includes(
        '/cart/add'
      )
    ) {
      scheduleCalculation(500);
    }

    return response;
  };

  calculateCartShipping();
});